import { ReactNode } from "react"

const colors = {
    success: "green-2",
    warning: "yellow-0",
    error: "red-3",
}

export enum BadgeType {
    SUCCESS = "success",
    WARNING = "warning",
    ERROR = "error",
}
interface BadgeProps {
    type: BadgeType
    children: ReactNode
}

export function Badge({ type, children }: BadgeProps) {
    return (
        <span
            className={`d-inline-block font-size-2 px-1 line-height-3 border-radius-2 font-weight-1 color-white bg-${colors[type]}`}
        >
            {children}
        </span>
    )
}
